export default __webpack_public_path__ + "static/OpenSans-Medium-9c83f68b7d221d184741823743e54b65.woff2";